import { useNavigate } from 'react-router-dom';
import { T } from '@design/index';
import { GOV_TYPE, govPageContainer } from '../ui/PatientUIGovernor';

/**
 * Honest App Lock surface.
 *
 * There is no app-lock implementation in the web app: no PIN is ever created,
 * and nothing gates any screen. The previous version rendered an "Enable"
 * toggle that flipped a flag and showed "Status: Enabled" while protecting
 * nothing — a false sense of security on a health-data app. Until a real
 * lock exists, this page says exactly that and points to real protections.
 */
export default function PatientAppLock() {
  const navigate = useNavigate();

  return (
    <div style={{ ...govPageContainer(), display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ background: T.white, border: `1px solid ${T.border}`, borderRadius: 16, padding: 16, boxShadow: T.shadow }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: `${T.navy}10`, display: 'grid', placeItems: 'center' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={T.navy} strokeWidth="2" strokeLinecap="round"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0110 0v4" /></svg>
          </div>
          <div>
            <div style={GOV_TYPE.pageTitle}>App Lock</div>
            <div style={{ fontSize: 9, color: T.textSec, fontFamily: T.font }}>In-app PIN / biometric lock</div>
          </div>
        </div>
      </div>

      <div style={{ background: '#FFFBEB', border: '1px solid #FDE68A', borderRadius: 12, padding: 14 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#92400E', fontFamily: T.font, marginBottom: 4 }}>
          App Lock is not available in the web app yet
        </div>
        <div style={{ fontSize: 10, color: '#92400E', fontFamily: T.font, lineHeight: 1.7 }}>
          A PIN/biometric lock for this app has not been built — no toggle here would actually
          protect anything, so none is shown. Until it ships, protect your health data with:
          <br />• your device's own screen lock (PIN, fingerprint, or face unlock)
          <br />• signing out when using a shared device
        </div>
      </div>

      <div style={{ background: `${T.info}08`, border: `1px solid ${T.info}20`, borderRadius: 12, padding: 12 }}>
        <div style={{ fontSize: 10, fontWeight: 700, color: T.info, fontFamily: T.font, marginBottom: 4 }}>What protects your records today</div>
        <div style={{ fontSize: 9, color: T.textSec, fontFamily: T.font, lineHeight: 1.6 }}>
          Your NeoHealthCard session requires login, and medical record sharing is controlled by the
          consent grants you manage in Consent &amp; Sharing.
        </div>
      </div>

      <button
        onClick={() => navigate('/patient/settings')}
        style={{ width: '100%', padding: '12px 0', borderRadius: 10, background: T.teal, color: '#FFF', fontWeight: 700, fontSize: 12, border: 'none', cursor: 'pointer', fontFamily: T.font }}
      >
        Back to Settings
      </button>
    </div>
  );
}
